export default {
  link: {
    id: 'cart_unavailable_bouygues_cancel',
    defaultMessage: 'Cancel device order',
  },
  title: {
    id: 'cart_unavailable_bouygues_cancel_title',
    defaultMessage: 'Cancel device order',
  },
  paragraph1: {
    id: 'cart_unavailable_bouygues_cancel_modal_description1',
    defaultMessage:
      'We’re unable to cancel your order at this time. To make changes to your device order or mobile plan, talk with a Bouygues representative.',
  },
  paragraph2: {
    id: 'cart_unavailable_bouygues_cancel_modal_description2',
    defaultMessage:
      'Wait for your link to expire with the timer above, then contact Bouygues Customer Care for next steps.',
  },
  confirm: {
    id: 'cart_unavailable_bouygues_cancel_confirm',
    defaultMessage: 'Confirm cancellation',
  },
  close: {
    id: 'cart_unavailable_bouygues_cancel_close',
    defaultMessage: 'Close',
  },
}
